import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, trackRouteMetaEvents } from "./metaPixel";
import { gaPageView } from "./ga4";

/**
 * Scroll reset + analytics on every route change.
 * GA4 page_view fires on initial load and every pathname/search change.
 * Meta PageView skips the first load because index.html already fires one.
 */
export default function ScrollToTop() {
  const location = useLocation();
  const isInitialMetaPageView = useRef(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    trackRouteMetaEvents(location.pathname);

    if (isInitialMetaPageView.current) {
      isInitialMetaPageView.current = false;
    } else {
      trackPageView();
    }

    // Helmet sets document.title in a later effect. Defer with a timer (not rAF,
    // which never fires in a background tab) so GA gets the new page's title.
    const timer = window.setTimeout(() => {
      gaPageView({
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname + location.search,
      });
    }, 0);

    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
}
